<template>
  <div>
    <div class="flex flex-1 justify-end mb-8">
      <inertia-link :href="route('shop.account.addresses.add')" class="btn-gray">Adaugă adresă</inertia-link>
    </div>
    <div v-for="(address, index) in $page.auth.user.addresses" :key="index">
      <address-card class="mb-4" :address="address" />
    </div>
    <div v-if="!$page.auth.user.addresses.length" class="flex justify-center items-center p-10">
      <span class="text-xl text-gray-700">Nu au fost adăugate adrese.</span>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import AccountLayout from '@/Shared/Account/Layout'
import AddressCard from '@/Shared/Account/AddressCard'

export default {
  metaInfo() {
    return {
      title: 'Adrese',
      meta: [ 
        { name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive' },
        { name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive' }
      ]
    }
  },
  layout: (h, page) => {
    return h(Layout, [
      h(AccountLayout, [page]),
    ])
  },
  components: {
    AccountLayout,
    Layout,
    AddressCard
  }
}
</script>
